<svg-outlet></svg-outlet>
<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
<router-outlet name="print"></router-outlet>
<lum-overrides></lum-overrides>
<div id="react-outlet"></div>
<app-global-search></app-global-search>
